module.exports = __webpack_public_path__ + "static/media/Second.d6ef3c4a.jpg";